

import React from 'react';
import propTypes from 'prop-types';
import {connect} from 'react-redux';
import render from '../render';

import Trip from './Trip';
import TrafficRegulations from './TrafficRegulations';
import LocalAttraction from './LocalAttraction';
import FooterSave from './FooterSave';
import GuideBar from './GuideBar';
import MyCar from './MyCar';

import { hide } from '../../components/Loading';

import {
  FlexLayout,
  FlexLayoutBody,
  FlexLayoutHeader,
  FlexLayoutFooter
} from '../../components/FixedLayout';
import TripDayTabbar from '../../components/TripDayTabbar';

import './style.css';

import * as tripAction from '../../store/actions/trip';
import {parseQuery} from '../../utils/url';
import {render as renderLocalState, ready, get as getLocalState} from '../../store/localState';
import * as selector from './selector';
import nativeEvent from '../../native/event';
import listenPhysicsBackButton from '../../native/listenPhysicsBackButton';
import * as navigator from '../../native/navigator';
import setLeftPanGesture from '../../native/setLeftPanGesture';
import renderNavbarRightButtons from '../../native/renderNavbarRightButtons';
import renderNavbarRightPopover from '../../native/renderNavbarRightPopover';
import renderNavbarLeftButton from '../../native/renderNavbarLeftButton';
import setTitle from '../../native/setTitle';
import {show as showLoading} from '../../components/Loading';
import share from '../../native/share';
import * as tripHelper from '../../helpers/trip';
import toast from '../../native/toast';
import InitScreen from '../../components/InitScreen';
import EditButton from './Trip/EditButton2/';
import {sendStatsEvent} from '../../components/statistics/';
import {isShare, isCopyTripReturn} from './from';
import confirm from '../../components/Confirm';
import {loginUrl} from '../../config';
import servicesReport from '../../services/report';
import * as WechatShare from './share';
import Detector from '../../utils/detector';


const query = parseQuery();
servicesReport({
  trip_id: query.trip_id,
  type: 'open_trip',
  val: (query.type || 'all')
});

class TripContainer extends React.Component {
  static propTypes = {
    day: propTypes.number.isRequired,
    trip: propTypes.object.isRequired
  };

  render() {
    let {day, trip} = this.props;

    return (
      <FlexLayout id='trip'>
        <FlexLayoutHeader>
          {this.renderGuideBar()}
          <TripDayTabbar days={trip.trip_days} current={day} />
        </FlexLayoutHeader>
        <FlexLayoutBody className="trip-body">
          <Trip day={day} trip={trip} />
          {this.renderMyCar()}
          {this.renderTrafficRegulations()}
          <LocalAttraction day={day} trip={trip} />
        </FlexLayoutBody>
        {this.renderFooter()}

        {isShare() || isCopyTripReturn() ? null : <EditButton day={day} trip={trip}/> }
      </FlexLayout>
    );
  }

  renderTrafficRegulations() {
    let {day, trip} = this.props;
    if (day !== 0) return null;

    return (<TrafficRegulations trip_id={trip.trip_id} />);
  }

  renderMyCar() {
    let {day, trip} = this.props;
    if (day !== 0 || !trip) return null;

    return (<MyCar trip_id={trip.trip_id} />);
  }

  renderGuideBar() {
    if (!isCopyTripReturn()) {
      return null;
    }

    return (<GuideBar />);
  }

  renderFooter() {
    let {trip} = this.props;

    if (!isShare()) {
      return null;
    }

    return (
      <FlexLayoutFooter>
        <FooterSave trip={trip} />
      </FlexLayoutFooter>
    );
  }

  componentDidMount() {
    let {trip} = this.props;
    let newTitle = tripHelper.getTitle(trip);
    setTitle(newTitle);
  }

}


// 请求核心数据（加载了核心数据才渲染组件），否则loading状态
class InitPage extends React.Component {
  state = {
    ownDay: 0
  }

  static propTypes = {
    initStatus: propTypes.string,
    trip: propTypes.object,
    day: propTypes.number,

    renderLocalState: propTypes.func.isRequired,
    getOne: propTypes.func.isRequired,
    deleteOne: propTypes.func.isRequired,
    selectDay: propTypes.func.isRequired
  };

  render() {
    let {initStatus, trip, day} = this.props;
    // 这里本来是直接用props传过来的day，但是由于行程编辑页trip-edit2里的day索引和这里的不相同，导致返回到这里的时候day会往前推一天，所以在初始化的时候直接将day+1赋值到state中
    // let { ownDay } = this.state;

    return (
      <InitScreen
        loadImage="tripLoadImage.svg"
        status={initStatus}
        component={TripContainer}
        trip={trip}
        day={day} />
    );
  }

  componentDidMount() {
    // const _this = this;
    // nativeEvent.on('webview-show', function () {
    //   console.log(_this);
    //   console.log(_this.props);
    //   const { day } = _this.props;
    //   _this.setState({
    //     ownDay: day > 0 ? day + 1 : day
    //   });
    // });
    this.initData();
    this.handleNativeEvent();
    this.renderNavbarRightButtons();
    this.renderNavBarLeftButton();
  }

  // componentWillReceiveProps(nextProps) {
  //   if (nextProps.day !== this.props.day) {
  //     this.setState({
  //       ownDay: nextProps.day
  //     });
  //   }
  // }

  initData() {
    let {renderLocalState, getOne, selectDay} = this.props;

    renderLocalState();
    ready(function (state) {
      selectDay(query.day);

      getOne(query.trip_id)
        .then((res)=>{
          if(res){
            WechatShare.init(res);
          }
        })
        .catch(function (err) {
          if (err.code === 20300 || err.code === 20011) {
            hide();
            confirm({
              content: '您还没登录当前行程的帐号，请先登录后方可查看行程',
              confirmText: '去登录',
              cancelText: false,
              confirmCallback: function () {
                navigator.push(loginUrl, {
                  nc_login: 1,
                  ref: window.location.href
                });
              }
            });
          } else {
            toast(err.message);
          }
        });
    });
  }

  handleNativeEvent() {
    let {renderLocalState} = this.props;

    nativeEvent.on('webview-show', ()=>{
      console.log(456);
      setTimeout(() => {
        renderLocalState();

        let localState = getLocalState();
        let trip = localState.entity.trip[query.trip_id];
        let newTitle = tripHelper.getTitle(trip);
        setTitle(newTitle);
      }, 100);
    });

  
    let version = Detector.browser.fullVersion.split('.');
    const removeTripLeftButtonEvent = version[0] >= 1 && version[1] >= 4;
    if(!removeTripLeftButtonEvent){
      //android物理返回按钮
      listenPhysicsBackButton(function () {
        navigator.backHome();
      });
      //iOS手势返回
      setLeftPanGesture(2);
    }
    
    // navbar右按钮组
    nativeEvent.on('navbar-right-buttons-click', this.handleNavbarRightButtons);

    nativeEvent.on('navbar-right-popover-click', this.handleNavbarRightPopover);

    nativeEvent.on('navbar-left-button-click', this.handleNavbarLeft);
  }

  handleNavbarRightButtons = (index) => {
    console.log(123);
    if (index === 0) {
      this.renderNavbarRightPopover();
    }
  };

  handleNavbarRightPopover = (index) => {
    let {trip, deleteOne} = this.props;

    switch (index) {
      case 0:
        sendStatsEvent('trip_share_click_2');
        let options = tripHelper.getShareOptions(trip);
        share(options);
        break;
      case 1:
        sendStatsEvent('trip_set_cilck_2');
        navigator.push('/m/v2/?m=render2&page=trip-settings', {
          trip_id: trip.trip_id
        });
        break;
      case 2:
        confirm({
          content: '是否要删除这条行程？',
          confirmText: '是',
          cancelText: '否',
          confirmCallback: function () {
            sendStatsEvent('trip_delete_2');
            let hide = showLoading();
            deleteOne(trip.trip_id)
              .then(function () {
                toast('成功删除');
                navigator.backHome();
              })
              .catch(function (err) {
                toast(err.message);
              })
              .finally(function () {
                hide();
              });
          }
        });
        break;
      default:
        // TODO
    }
  };

  renderNavbarRightButtons() {
    renderNavbarRightButtons([
      {icon: 'more', id: 'more', topIcon: 'more_top'}
    ]);
  }

  renderNavbarRightPopover() {
    renderNavbarRightPopover([
      {title: '分享', id: 'share'},
      {title: '设置', id: 'setting'},
      {title: '删除', id: 'del', color: '#ff0000'}
    ]);
  }
  
  renderNavBarLeftButton(){
    renderNavbarLeftButton({
      type: 'image',
      imageUrl: 'back',
      topImageUrl:'',
      text: '',
      textColor:'', 
      success: function (response) {
        console.log(response);
      }
    });
  }

  handleNavbarLeft = ()=>{
    if(query.step == 'profile'){
      navigator.backHome('profile');
    }else{
      navigator.back(query.step);
    }
    
  }
}


const Connector = connect(function (state, ownProps) {
  let trip = selector.trip(state, query.trip_id);
  let day = selector.day(state, trip);
  let initStatus = selector.initStatus(state, trip);
  return {day, trip, initStatus};
}, {
  ...tripAction,
  renderLocalState
})(InitPage);


render(Connector);




// WEBPACK FOOTER //
// ./src/pages/trip/index.js